import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../auth/base-api.service';
import { RequestTypeEnum } from 'src/app/utils/enums';

export interface ICorrectionList {
  words: ICorrectionListItem[];
  count: 0;
}

export interface ICorrectionListItem {
  id: number;
  word: string;
  langCode: string;
}

@Injectable({
  providedIn: 'root'
})
export class CorrectionListApiService extends BaseApiService {
  private correctedWordsApiUrl = environment.conversions.baseUrl + '/api/v1/correctedwords';

  constructor(
    public http: HttpClient,
  ) {
    super(http);
  }

  async getCorrectionList(langCode: string, skip: number, take: number): Promise<ICorrectionList> {
    const headers = {
      Language: langCode
    };

    const params = {
      skip: skip.toString(),
      take: take.toString(),
    };

    return this.get<ICorrectionList>(
      `${this.correctedWordsApiUrl}?${this.toQueryParams(params)}`,
      { headers: { ...headers } },
      RequestTypeEnum.CorrectionList
    );
  }

  async addWord(word: string, langCode: string) {
    const headers = {
      Language: langCode
    };

    const params = {
      word
    };

    return this.post(
      `${this.correctedWordsApiUrl}?${this.toQueryParams(params)}`,
      null,
      { headers: { ...headers } },
      RequestTypeEnum.CorrectionListAddWord
    );
  }

  async deleteWord(id: number, langCode: string) {
    const url = `${this.correctedWordsApiUrl}/${id}`;

    const headers = {
      Language: langCode
    };

    return this.delete(
      url,
      { headers: { ...headers } },
      RequestTypeEnum.CorrectionListDeleteWord
    );
  }
}
